import React from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import TLinkApi from "services/tlink.api";
import { useSnackbar } from "notistack";
import { Backdrop, CircularProgress, Icon, IconButton } from "@mui/material";
import { useForm, Controller } from "react-hook-form";

const VendorSupplyConfig = () => {
  const navigate = useNavigate();
  const { vendor, setVendor, isEdit, setIsEdit } = useOutletContext();
  let { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [dataEdit, setDataEdit] = useState(false);
  const { id } = useParams();

  const {
    control,
    watch,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
    register,
  } = useForm({
    defaultValues: {
      id: "",
      minCpi: "",
      maxCpi: "",
      minIr: "",
      maxIr: "",
      minLoi: "",
      maxLoi: "",
      minVcpi: "",
      maxVcpi: "",
      minConversion: "",
      minEpc: "",
      minClientStarts: "30",
      maxConversion: "100",
      minSampleRequired: "",
    },
  });

  useEffect(() => {
    getData();
  }, [vendor]);

  async function getData() {
    setIsLoading(true);
    if (id) {
      try {
        let result = await TLinkApi.get(`/vendors/supply/config/${id}`);
        if (result.status !== 404 && Object.keys(result.data).length > 0) {
          setDataEdit(true);
          const payload = {
            minConversion: result.data.minConversion,
            id: result.data.id,
            minCpi: result.data.minCpi,
            maxCpi: result.data.maxCpi,
            minIr: result.data.minIr,
            maxIr: result.data.maxIr,
            minLoi: result.data.minLoi,
            maxLoi: result.data.maxLoi,
            minVcpi: result.data.minVcpi,
            maxVcpi: result.data.maxVcpi,
            minClientStarts: result.data.minClientStarts,
            maxConversion: result.data.maxConversion,
            minSampleRequired: result.data.minSampleRequired,
            minEpc: result.data.minEpc,
          };
          reset(payload);
        } else {
          setDataEdit(false);
        }
        setIsLoading(false);
      } catch (e) {
        setIsLoading(false);
      }
    }
  }

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  const save = async (data) => {
    setIsLoading(true);

    try {
      if (dataEdit === true) {
        let payloadId = data.id;

        let put_payload = {
          min_cpi: Number(data.minCpi),
          max_cpi: Number(data.maxCpi),
          min_ir: Number(data.minIr),
          max_ir: Number(data.maxIr),
          min_loi: Number(data.minLoi),
          max_loi: Number(data.maxLoi),
          min_vcpi: Number(data.minVcpi),
          max_vcpi: Number(data.maxVcpi),
          min_conversion: Number(data.minConversion),
          min_epc: Number(data.minEpc),
          min_client_starts: Number(data.minClientStarts),
          max_conversion: Number(data.maxConversion),
          min_sample_required: Number(data.minSampleRequired),
        };

        let result = await TLinkApi.put(
          `/vendors/supply/config/${payloadId}`,
          put_payload
        );
        setIsLoading(false);
        setVendor({});
        getData();
        // navigate("/vendors");
        enqueueSnackbar(result?.message, {
          variant: "success",
        });
      } else {
        let post_payload = {
          vendor_id: parseInt(id),
          min_cpi: Number(data.minCpi),
          max_cpi: Number(data.maxCpi),
          min_ir: Number(data.minIr),
          max_ir: Number(data.maxIr),
          min_loi: Number(data.minLoi),
          max_loi: Number(data.maxLoi),
          min_vcpi: Number(data.minVcpi),
          max_vcpi: Number(data.maxVcpi),
          min_conversion: Number(data.minConversion),
          min_epc: Number(data.minEpc),
          min_client_starts: Number(data.minClientStarts),
          max_conversion: Number(data.maxConversion),
          min_sample_required: Number(data.minSampleRequired),
        };

        let result = await TLinkApi.post(
          "vendors/supply/config/",
          post_payload
        );
        setIsLoading(false);
        enqueueSnackbar(result?.message, {
          variant: "success",
        });

        setVendor({});
        // navigate("/vendors");
        getData();
      }
    } catch (e) {
      setIsLoading(false);
      enqueueSnackbar(e?.message, {
        variant: "error",
      });
    }
  };

  const ingerNum = (e) => {
    const characterCode = e.key;
    if (characterCode === "Backspace") return;

    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      return;
    } else {
      e.preventDefault();
    }
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <form onSubmit={handleSubmit(save)} noValidate>
        <Grid container spacing={3} px={2}>
          <Grid item xs={12} md={12}></Grid>
        </Grid>
        <MDBox
          p={2}
          style={{
            border: "1px solid #D9D9D9",
            backgroundColor: "white",
            borderRadius: "16px",
          }}
          m={2}
        >
          <MDBox
            px={2}
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MDBox>
              {isEdit.disabled === true && (
                <IconButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  onClick={() => {
                    setIsEdit({
                      disabled: false,
                      edit: true,
                    });
                  }}
                >
                  <Icon>border_color_icon</Icon>
                </IconButton>
              )}
            </MDBox>
          </MDBox>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <MDInput
                label="Min Cpi"
                value={watch("minCpi")}
                fullWidth
                required
                disabled={isEdit.disabled}
                type="number"
                autoComplete="off"
                variant="outlined"
                {...register("minCpi", {
                  required: "Min CPI is required!",
                  min: {
                    value: 0.0000,
                    message: "Min Cpi should be greater than or equal to 0",
                  },
                  max: {
                    value: watch("maxCpi"),
                    message: "Min Cpi should be smaller than Max Cpi",
                  },
                })}
                placeholder="Min Cpi"
                error={errors?.minCpi ? true : false}
                helperText={
                  errors?.minCpi && errors.minCpi.message !== ""
                    ? errors.minCpi.message
                    : errors?.minCpi?.type === "max"
                    ? "Max Cpi cannot be smaller than Min Cpi"
                    : null
                }
                InputProps={{
                  inputProps: {
                    step: 0.01,
                  },
                }}
                onBlur={(e) => {
                  const roundedValue = parseFloat(e.target.value).toFixed(2);
                  setValue("minCpi", roundedValue);
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MDInput
                label="Max Cpi"
                value={watch("maxCpi")}
                fullWidth
                required
                disabled={isEdit.disabled}
                type="number"
                autoComplete="off"
                variant="outlined"
                {...register("maxCpi", {
                  required: "Max Cpi is required!",
                  min: {
                    value: watch("minCpi"),
                    message: "Max Cpi should be greater than Min Cpi",
                  },
                })}
                placeholder="Max Cpi"
                error={errors?.maxCpi ? true : false}
                helperText={
                  errors?.maxCpi && errors.maxCpi.message !== ""
                    ? errors.maxCpi.message
                    : errors?.maxCpi?.type === "min"
                    ? "Min Cpi cannot be greater than Max Cpi"
                    : null
                }
                InputProps={{
                  inputProps: {
                    step: 0.01,
                  },
                }}
                onBlur={(e) => {
                  const roundedValue = parseFloat(e.target.value).toFixed(2);
                  setValue("maxCpi", roundedValue);
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MDInput
                label="Min Ir"
                value={watch("minIr")}
                fullWidth
                required
                disabled={isEdit.disabled}
                type="number"
                autoComplete="off"
                variant="outlined"
                {...register("minIr", {
                  required: "Min Ir is required!",
                  min: {
                    value: 0.0000,
                    message: "Min Ir should be greater than or equal to 0",
                  },
                  max: {
                    value: watch("maxIr"),
                    message: "Min Ir should be smaller than Max Ir",
                  },
                })}
                placeholder="Min IR"
                error={errors?.minIr ? true : false}
                helperText={
                  errors?.minIr && errors.minIr.message !== ""
                    ? errors.minIr.message
                    : errors?.minIr?.type === "max"
                    ? "Max Ir cannot be smaller than Min Ir"
                    : null
                }
                InputProps={{
                  inputProps: {
                    step: 0.01,
                  },
                }}
                onBlur={(e) => {
                  const roundedValue = parseFloat(e.target.value).toFixed(2);
                  setValue("minIr", roundedValue);
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MDInput
                label="Max Ir"
                value={watch("maxIr")}
                fullWidth
                required
                disabled={isEdit.disabled}
                type="number"
                autoComplete="off"
                variant="outlined"
                {...register("maxIr", {
                  required: "Max Ir is required!",
                  min: {
                    value: watch("minIr"),
                    message: "Max Ir should be greater than Min Ir",
                  },
                })}
                placeholder="Max IR"
                error={errors?.maxIr ? true : false}
                helperText={
                  errors?.maxIr && errors.maxIr.message !== ""
                    ? errors.maxIr.message
                    : errors?.maxIr?.type === "min"
                    ? "Min Ir cannot be greater than Max Ir"
                    : null
                }
                InputProps={{
                  inputProps: {
                    step: 0.01,
                  },
                }}
                onBlur={(e) => {
                  const roundedValue = parseFloat(e.target.value).toFixed(2);
                  setValue("maxIr", roundedValue);
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MDInput
                label="Min Loi"
                value={watch("minLoi")}
                fullWidth
                required
                disabled={isEdit.disabled}
                type="number"
                autoComplete="off"
                variant="outlined"
                {...register("minLoi", {
                  required: "Min Loi is required!",
                  min: {
                    value: 0.0000,
                    message: "Min Loi should be greater than or equal to 0",
                  },
                  max: {
                    value: watch("maxLoi"),
                    message: "Min Loi should be smaller than Max Loi",
                  },
                  validate: (value) => {
                    if (value % 1 !== 0) {
                      return "Please enter an integer value for Min Loi";
                    }
                    return true;
                  },
                })}
                placeholder="Min Loi"
                error={errors?.minLoi ? true : false}
                helperText={
                  errors?.minLoi && errors.minLoi.message !== ""
                    ? errors.minLoi.message
                    : errors?.minLoi?.type === "max"
                    ? "Max Loi cannot be smaller than Min Loi"
                    : null
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MDInput
                label="Max Loi"
                value={watch("maxLoi")}
                fullWidth
                required
                disabled={isEdit.disabled}
                type="number"
                autoComplete="off"
                variant="outlined"
                {...register("maxLoi", {
                  required: "Max Loi is required!",
                  min: {
                    value: watch("minLoi"),
                    message: "Max Loi should be greater than Min Loi",
                  },
                  validate: (value) => {
                    if (value % 1 !== 0) {
                      return "Please enter an integer value for Max Loi";
                    }
                    return true;
                  },
                })}
                placeholder="Max Loi"
                error={errors?.maxLoi ? true : false}
                helperText={
                  errors?.maxLoi && errors.maxLoi.message !== ""
                    ? errors.maxLoi.message
                    : errors?.maxLoi?.type === "min"
                    ? "Min Loi cannot be greater than Max Loi"
                    : null
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MDInput
                label="Min VCpi"
                value={watch("minVcpi")}
                fullWidth
                required
                disabled={isEdit.disabled}
                type="number"
                autoComplete="off"
                variant="outlined"
                {...register("minVcpi", {
                  required: "Min Vcpi is required!",
                  min: {
                    value: 0,
                    message: "Min VCpi should be greater than or equal to 0",
                  },
                  max: {
                    value: watch("maxVcpi"),
                    message: "Min VCpi should be smaller than Max VCpi",
                  },
                })}
                placeholder="Min VCpi"
                error={errors?.minVcpi ? true : false}
                helperText={
                  errors?.minVcpi && errors.minVcpi.message !== ""
                    ? errors.minVcpi.message
                    : errors?.minVcpi?.type === "max"
                    ? "Max VCpi cannot be smaller than Min VCpi"
                    : null
                }
                InputProps={{
                  inputProps: {
                    step: 0.01,
                  },
                }}
                onBlur={(e) => {
                  const roundedValue = parseFloat(e.target.value).toFixed(2);
                  setValue("minVcpi", roundedValue);
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MDInput
                label="Max VCpi"
                value={watch("maxVcpi")}
                fullWidth
                required
                disabled={isEdit.disabled}
                type="number"
                autoComplete="off"
                variant="outlined"
                {...register("maxVcpi", {
                  required: "Max Vcpi is required!",
                  min: {
                    value: watch("minVcpi"),
                    message: "Max VCpi should be greater than Min VCpi",
                  },
                })}
                placeholder="Max VCpi"
                error={errors?.maxVcpi ? true : false}
                helperText={
                  errors?.maxVcpi && errors.maxVcpi.message !== ""
                    ? errors.maxVcpi.message
                    : errors?.maxVcpi?.type === "min"
                    ? "Min VCpi cannot be greater than Max VCpi"
                    : null
                }
                InputProps={{
                  inputProps: {
                    step: 0.01,
                  },
                }}
                onBlur={(e) => {
                  const roundedValue = parseFloat(e.target.value).toFixed(2);
                  setValue("maxVcpi", roundedValue);
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Controller
                name="minConversion"
                control={control}
                rules={{
                  required: "Min Conversion is required!",
                }}
                render={({ field }) => (
                  <MDInput
                    label="Min Conversion"
                    {...field}
                    fullWidth
                    required
                    disabled={isEdit.disabled}
                    type="number"
                    autoComplete="off"
                    variant="outlined"
                    {...register("minConversion", {
                      min: {
                        value: 0.0000,
                        message: "Min Conversion should be greater than or equal to 0",
                      },
                    })}
                    placeholder="Min Conversion"
                    error={errors?.minConversion ? true : false}
                    helperText={
                      errors?.minConversion &&
                      errors.minConversion.message !== ""
                        ? errors.minConversion.message
                        : null
                    }
                    InputProps={{
                      inputProps: {
                        step: 0.01,
                      },
                    }}
                    onBlur={(e) => {
                      const roundedValue = parseFloat(e.target.value).toFixed(
                        2
                      );
                      setValue("minConversion", roundedValue);
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="maxConversion"
                control={control}
                rules={{
                  required: "Max Conversion is required!",
                }}
                render={({ field }) => (
                  <MDInput
                    label="Max Conversion"
                    {...field}
                    fullWidth
                    required
                    disabled={isEdit.disabled}
                    type="number"
                    autoComplete="off"
                    variant="outlined"
                    {...register("maxConversion", {
                      min: {
                        value: watch("minConversion"),
                        message:
                          "Max Conversion should be greater than Min Conversion ",
                      },
                    })}
                    error={errors?.maxConversion ? true : false}
                    helperText={
                      errors?.maxConversion &&
                      errors.maxConversion.message !== ""
                        ? errors.maxConversion.message
                        : null
                    }
                    InputProps={{
                      inputProps: {
                        step: 0.01,
                      },
                    }}
                    onBlur={(e) => {
                      const roundedValue = parseFloat(e.target.value).toFixed(
                        2
                      );
                      setValue("maxConversion", roundedValue);
                    }}
                    placeholder="Max Conversion"
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="minSampleRequired"
                control={control}
                rules={{
                  required: "Min SampleRequired is required!",
                  pattern: {
                    value: /^[0-9]+$/,
                    message:
                      "Please enter a valid integer for Min SampleRequired",
                  },
                }}
                render={({ field }) => (
                  <MDInput
                    label="Min SampleRequired"
                    {...field}
                    fullWidth
                    required
                    disabled={isEdit.disabled}
                    type="number"
                    autoComplete="off"
                    {...register("minSampleRequired", {
                      min: {
                        value: 0.0000,
                        message: "Min Sample Required should be greater than 0",
                      },
                    })}
                    variant="outlined"
                    placeholder="Min SampleRequired"
                    error={errors?.minSampleRequired ? true : false}
                    helperText={
                      errors?.minSampleRequired
                        ? errors.minSampleRequired.message
                        : null
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="minEpc"
                control={control}
                rules={{
                  required: "Min Epc is required!",
                }}
                render={({ field }) => (
                  <MDInput
                    label="Min Epc"
                    {...field}
                    fullWidth
                    required
                    disabled={isEdit.disabled}
                    type="number"
                    autoComplete="off"
                    variant="outlined"
                    {...register("minEpc", {
                      min: {
                        value: 0.0000,
                        message: "Min Epc should be greater than or equal to 0",
                      },
                    })}
                    placeholder="Min Epc"
                    error={errors?.minEpc ? true : false}
                    helperText={
                      errors?.minEpc && errors.minEpc.message !== ""
                        ? errors.minEpc.message
                        : null
                    }
                    InputProps={{
                      inputProps: {
                        step: 0.01,
                      },
                    }}
                    onBlur={(e) => {
                      const roundedValue =
                        Math.round(Number(e.target.value) * 100) / 100;
                      setValue("minEpc", roundedValue);
                    }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Controller
                name="minClientStarts"
                control={control}
                rules={{
                  required: "Min Client Starts is required!",
                }}
                render={({ field }) => (
                  <MDInput
                    label="Min Client Starts"
                    {...field}
                    fullWidth
                    required
                    disabled={isEdit.disabled}
                    type="number"
                    autoComplete="off"
                    variant="outlined"
                    {...register("minClientStarts", {
                      required: "Min Client Starts is required!",
                    })}
                    onKeyPress={(e) => {
                      ingerNum(e);
                    }}
                    error={errors?.minClientStarts ? true : false}
                    helperText={
                      errors?.minClientStarts &&
                      errors.minClientStarts.message !== ""
                        ? errors.minClientStarts.message
                        : null
                    }
                    placeholder="Min Client Starts"
                  />
                )}
              />
            </Grid>
          </Grid>
        </MDBox>

        {isEdit.disabled !== true && (
          <MDBox
            pt={2}
            px={2}
            mb={4}
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap="10px"
          >
            <MDButton
              variant="outlined"
              color="dark"
              onClick={() => {
                setIsEdit({
                  disabled: false,
                  edit: false,
                });
                setVendor({});
                navigate("/vendors");
              }}
            >
              &nbsp;cancel
            </MDButton>
            <MDButton variant="gradient" color="info" type="submit">
              Save
            </MDButton>
          </MDBox>
        )}
      </form>
      {isEdit.disabled === true && (
        <MDBox
          py={2}
          px={2}
          mb={4}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          gap="10px"
        >
          <MDButton
            variant="outlined"
            color="dark"
            onClick={() => {
              setIsEdit({
                disabled: false,
                edit: false,
              });
              setVendor({});
              navigate("/vendors");
            }}
          >
            &nbsp;cancel
          </MDButton>
          <MDButton
            variant="gradient"
            color="info"
            onClick={() => {
              setIsEdit({
                disabled: false,
                edit: true,
              });
              navigate(`/vendors/${id}/integrationConfig/edit`);
            }}
          >
            Next
          </MDButton>
        </MDBox>
      )}
    </>
  );
};

export default VendorSupplyConfig;
